import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.documents;

export default class Documents extends Model {
  static entity = `${name}`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      description: this.string(''),
      file: this.string(''),
      order: this.number(0),
    };
  }

  static methodConf = {
    http: {
      url: '',
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/catalog/documents',
          method: 'get',
        },
      },
    },
  };
}
